import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: []
    },
    lastName: {
      validations: []
    },
    email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    theme: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Preferred event date must be in the future' }
      ]
    },
    plannedguestcount: {
      validations: []
    },
    Notes: {
      validations: []
    },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:',
            mapping: 'firstName'
          },
        ]
      },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Last Name:',
           mapping: 'lastName'
         }
       ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:',
            mapping: 'email'
          },
         ]
        },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Phone:',
           mapping: 'telnumber'
         }
       ]
     },
     {
      fields: [
        {
          type: 'text',
          size: 'Medium',
          label: 'Event Type:',
          mapping: 'theme'
        }
      ]
    },
        {
          fields: [
            {
              type: 'date-picker',
              size: 'Medium',
              label: 'Event Date:',
              mapping: 'eventDate'
            }
          ]
        },
         {
           fields: [
             {
                type: 'text',
                size: 'Medium',
                label: 'Estimated Guest Count:',
                mapping: 'plannedguestcount'
              }
            ]
          },
          {
            fields: [
              {
                type: 'text-area',
                size: 'Medium',
                label: 'Any Additional Details About Your Event?:',
                mapping: 'Notes'
              }
            ]
          },
      {
        fields: [
          {
            type: 'submit',
            size: 'Medium',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Fork and Flavor Catering Contact Form',
    formId: '785',
    clientKey: '229E6C53-2C4B-4B5A-84A0-6CC56C79E7A4',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
